var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import defaultPhoto from '../assets/images/profile.svg';
import { ProfilePhotoImgStyled, ProfilePhotoWrapperStyled } from './styled';
const ProfilePhoto = (_a) => {
    var props = __rest(_a, []);
    const { src: photoDriver, size } = props;
    return (_jsx(ProfilePhotoWrapperStyled, Object.assign({}, props, { children: _jsx(ProfilePhotoImgStyled, { size: size, src: photoDriver || defaultPhoto, alt: photoDriver ? 'profilePhoto' : 'defaultProfilePhoto' }) })));
};
ProfilePhoto.defaultProps = {
    size: 60,
};
export default ProfilePhoto;
//# sourceMappingURL=index.js.map